// extracted by mini-css-extract-plugin
export default {"root":"FaceFilter__root--2qDQE","arrow":"FaceFilter__arrow--3w2VK"};